import { useState } from "react";

const InfoTooltip = ({ content, position = "top" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const isVisible = isOpen || isHovered;

  const positionClasses = {
    top: "bottom-full left-1/2 transform -translate-x-1/2 mb-2",
    bottom: "top-full left-1/2 transform -translate-x-1/2 mt-2",
    left: "right-full top-1/2 transform -translate-y-1/2 mr-2",
    right: "left-full top-1/2 transform -translate-y-1/2 ml-2",
  };

  const arrowClasses = {
    top: "absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 rotate-45 w-2 h-2 bg-slate-800 border-r border-b border-slate-700",
    bottom: "absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rotate-45 w-2 h-2 bg-slate-800 border-l border-t border-slate-700",
    left: "absolute right-0 top-1/2 transform translate-x-1/2 -translate-y-1/2 rotate-45 w-2 h-2 bg-slate-800 border-r border-t border-slate-700",
    right: "absolute left-0 top-1/2 transform -translate-x-1/2 -translate-y-1/2 rotate-45 w-2 h-2 bg-slate-800 border-l border-b border-slate-700",
  };

  return (
    <div className="relative inline-flex items-center ml-1">
      <button
        onClick={() => setIsOpen(!isOpen)}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={`
          inline-flex items-center justify-center 
          w-4 h-4 rounded-full 
          transition-all duration-200
          ${isVisible 
            ? 'bg-blue-500 text-white ring-2 ring-blue-400 ring-offset-1 scale-110' 
            : 'bg-red-600 text-gray-600 hover:bg-blue-100 hover:text-blue-600 hover:ring-2 hover:ring-blue-200 animate-pulse'
          }
          focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2
        `}
        aria-label="Information"
        aria-expanded={isVisible}
        type="button"
      >
        <i className="ti ti-info-circle text-[10px]" />
      </button>
      
      {isVisible && (
        <div 
          className={`absolute z-[9999] ${positionClasses[position]} w-max max-w-[90vw] bg-slate-800 text-white rounded-lg shadow-2xl p-3 text-xs pointer-events-auto animate-in fade-in slide-in-from-bottom-2 duration-200 border border-slate-700`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-start justify-between gap-2">
            <div className="flex-1">{content}</div>
            <button 
              onClick={() => setIsOpen(false)}
              className="text-white/50 hover:text-white transition-colors p-0.5 flex-shrink-0"
              aria-label="Close tooltip"
              type="button"
            >
              <i className="ti ti-x text-sm" />
            </button>
          </div>
          <div className={arrowClasses[position]} />
        </div>
      )}
    </div>
  );
};

export default InfoTooltip